// extracted by mini-css-extract-plugin
export default {"main":"Main_main__6Seoj","filtersBox":"Main_filtersBox__V7Nda","filtersList":"Main_filtersList__6BwEC"};